<app-menu [isUserloggedIn]="isUserloggedIn()" [hasAccessToCemLive]="hasAccessToCemLive()" (loginAction)="login()" (logoutAction)="logout()" ></app-menu>
<div class="container">
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  @if (!isIframe) {
    <router-outlet></router-outlet>
  }
</div>
<app-common-error-ui></app-common-error-ui>
<app-common-footer></app-common-footer>